import {Flex, Input, Select, theme, Typography} from 'antd';
import ClearInputIcon from 'Components/InputAdornments/ClearInputIcon';
import React from 'react';

const {Text} = Typography;
const {TextArea, Password} = Input;

interface IProps {
  label: string;
  name: string;
  onChange: any;
  inline?: boolean;
  value?: string;
  reasonsMenu?: any;
  queryTypesMenu?: any;
  queryStatusMenu?: any;
  filterMenu?: any;
  disabled?: boolean;
  reset?: any;
  size?: any;
  isMultipleSelect?: boolean;
  autoFocus?: any;
}

const SELECT_FIELDS = [
  'client',
  'type',
  'escalationReason',
  'filter',
  'status',
  'srType',
  'createdBy',
  'owner',
  'subType',
  'sortBy',
  'sortOrder',
];

const CustomTextInput: React.FC<IProps> = (props) => {
  const {
    label,
    name,
    onChange,
    inline,
    value,
    reasonsMenu = [],
    queryTypesMenu = [],
    queryStatusMenu = [],
    filterMenu = [],
    disabled = false,
    reset = null,
    size,
    autoFocus,
    isMultipleSelect = false,
  } = props;
  const {token}: any = theme.useToken();

  const isSelectType = SELECT_FIELDS.includes(name);
  const antSize = size === 'small' ? 'small' : 'middle';

  // antd's Select reports the raw value (not a change event); bridge it back into
  // {target: {name, value}} so every existing formik.handleChange caller keeps working.
  const emitChange = (val: any) => onChange({target: {name, value: val}});

  const options: {label: string; value: any}[] =
    name === 'type' ||
    name === 'client' ||
    name === 'subType' ||
    name === 'srType' ||
    name === 'sortBy' ||
    name === 'sortOrder'
      ? (queryTypesMenu || []).map((query: any) => ({label: query, value: query}))
      : name === 'escalationReason'
      ? (reasonsMenu || []).map((reason: any) => ({label: reason.value, value: reason.value}))
      : name === 'filter'
      ? (filterMenu || []).map((filter: any) => ({label: filter, value: filter}))
      : name === 'status'
      ? (queryStatusMenu || []).map((status: any) => ({label: status, value: status}))
      : name === 'createdBy'
      ? (queryTypesMenu || []).map((query: any) => ({label: query.userName, value: query.userName}))
      : name === 'owner'
      ? (queryTypesMenu || []).map((query: any) => ({label: query.userName, value: query.id}))
      : [];

  const wrapperStyle: React.CSSProperties = {
    marginRight: inline ? 16 : undefined,
    flex: name === 'filter' ? 0.3 : 1,
    width: name === 'filter' ? 200 : undefined,
  };

  const labelStyle: React.CSSProperties = {
    fontSize: 17,
    fontWeight: 'bold',
    color: disabled ? token.colorTextDisabled : token.colorTextBase,
  };

  return (
    <Flex vertical gap={4} style={wrapperStyle}>
      <Text style={labelStyle}>{label}</Text>
      {isSelectType ? (
        <Select
          size={antSize}
          disabled={disabled}
          mode={isMultipleSelect ? 'multiple' : undefined}
          allowClear
          value={value || undefined}
          onChange={emitChange}
          options={options}
          style={name === 'filter' ? {backgroundColor: token.colorBgContainer} : undefined}
        />
      ) : name === 'comments' ? (
        <TextArea
          name={name}
          disabled={disabled}
          autoFocus={!!autoFocus}
          autoSize={{minRows: 2, maxRows: 2}}
          onChange={onChange}
          value={value === undefined ? '' : value}
        />
      ) : name === 'password' ? (
        <Password
          size={antSize}
          name={name}
          disabled={disabled}
          autoFocus={!!autoFocus}
          onChange={onChange}
          value={value === undefined ? '' : value}
        />
      ) : (
        <Input
          size={antSize}
          type={name === 'phoneNumber' ? 'number' : 'text'}
          name={name}
          disabled={disabled}
          autoFocus={!!autoFocus}
          onChange={onChange}
          value={value === undefined ? '' : value}
          suffix={reset && value ? <ClearInputIcon reset={reset} /> : undefined}
        />
      )}
    </Flex>
  );
};

export default CustomTextInput;
